import React, { Component } from 'react';
import Header from './layouts/Header';
import HeaderLoggedOut from './layouts/HeaderLoggedOut';
import Footer from './layouts/Footer';
import AOS from 'aos';
import Playlist from 'react-mp3-player';
import SideBar from './layouts/SideBar';
import { connect } from 'react-redux';
import { closePlayer } from './actions/media/media'


export class App extends Component {

    constructor(props) {
        super(props);
        setTimeout(() => {
            AOS.init({
                once: true,
                offset: 100,
                startEvent: 'load',
            });
        }, 500);

        this.state = {
            sidebar: true
        }
    }

    componentWillMount() {
        this.breakpoint = window.matchMedia( '(max-width: 1200px)' );
        const breakpointHandler = () => this.setState({ sidebar : this.breakpoint.matches });
        this.breakpoint.addListener( breakpointHandler );
        breakpointHandler();
    }

    componentWillReceiveProps(nextProps) {
        AOS.refresh();
        if (nextProps.location !== this.props.location) {
            window.previousPath = window.previousPath || [];
            window.previousPath.push(this.props.location.pathname);
        }
    }

    render() {
        const isUserLoggedIn = localStorage.token;

        const desktopOpts = {
            offset: {
                left: 300
            },
            breakpoint: {
                maxWidth: 770
            }
        };

        const mobileOpts = {
            offset: {
                left: 0
            },
            breakpoint: {
                maxWidth: 770
            }
        };
        const loginscreen = window.location.href.includes('login')
        const logged = (!isUserLoggedIn || loginscreen) ? false : true
        const isExpired = window.location.pathname === '/expired';
        return (
            <React.Fragment>
                {isUserLoggedIn ? !isExpired && <Header history={this.props.history} pathname={this.props.location.pathname} /> : <HeaderLoggedOut />}
                <div className='content-div'>
                    {logged && !isExpired && <SideBar pathname={this.props.location.pathname} />}
                    <div className='body-div'>
                        {this.props.children}
                        {!isUserLoggedIn || !this.props.location.pathname.includes('/expired') && <Footer pathname={this.props.location.pathname} />}
                        {this.props.showMp3 && <Playlist onClose={() => this.props.closePlayer()} tracks={this.props.mp3Tracks.podcastsList} opts={this.state.sidebar ? mobileOpts : desktopOpts} currentIndex={this.props.currentIndex} />}
                    </div>
                </div>
            </React.Fragment>
        )

    }
}

const mapStateToProps = state => {
    return {
        showMp3: state.media.showMp3,
        mp3Tracks: state.media.mp3Tracks,
        currentIndex: state.media.currentIndex
    }
};

const mapDispatchToProps = dispatch => {
    return {
        closePlayer: () => dispatch(closePlayer())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);


// WEBPACK FOOTER //
// src/client/App.js